import { configs } from '../configs';
import { FetchApi } from '../lib/anuket-http';

export async function searchRoster({eventCourseId, term, page, pageSize}) {
  const u = new URL(`${configs.athleteApiUrl}/roster/eventCourse/${eventCourseId}`)
  if (term) {
    u.searchParams.append('term', term)
  }
  if (page) {
    u.searchParams.append('page', page)
  }
  if (pageSize) {
    u.searchParams.append('pageSize', pageSize)
  }
  return new Promise((resolve, reject) => {
    FetchApi.memoizeFetch(10000)(
      u.href, {
        method: 'GET',
    })
    .subscribe((msg) => {
      if (msg.error) {
        reject(msg)
      }
      else {
        resolve(msg)
      }
    })
  })
}